export enum Lang {
    EN = 'en',
    HE = 'he',
    RU = 'ru'
}

export const DEFAULT_LANG = Lang.EN